module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "flex-space-between panel-block"
  }, [_c('div', {
    staticClass: "input-container"
  }, [(!_vm.editing) ? _c('a', {
    attrs: {
      "href": _vm.url,
      "target": _vm.id
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('input', {
    ref: "resource",
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.title
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [(!_vm.editing) ? _c('input', {
    staticClass: "button is-small",
    attrs: {
      "type": "button",
      "value": "edit",
      "name": "edit"
    },
    on: {
      "click": function($event) {
        _vm.editing = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('input', {
    staticClass: "button is-small is-danger",
    attrs: {
      "type": "button",
      "value": "delete",
      "name": "delete"
    },
    on: {
      "click": function($event) {
        _vm.showModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('button', {
    staticClass: "button is-small",
    class: _vm.updating && 'is-loading',
    attrs: {
      "type": "button",
      "name": "save"
    },
    on: {
      "click": function($event) {
        _vm.update()
      }
    }
  }, [_vm._v("\n      save\n    ")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('input', {
    staticClass: "button is-small",
    attrs: {
      "type": "button",
      "value": "cancel",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('Confirm', {
    attrs: {
      "loading": _vm.deleting,
      "title": "Deleting Resource",
      "message": "Are you sure you want to delete the resource?",
      "show": _vm.show
    },
    on: {
      "cancel": function($event) {
        _vm.show = false
      },
      "confirm": function($event) {
        _vm.remove()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-43af7d60"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resource.vue
// module id = 1016
// module chunks = 0